// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"a94cf52f","237":"f0be7306","411":"f682ba23","480":"b5aeddfc","655":"77735ad5","744":"656933c1","801":"bfaf7c59","866":"8bdf67fc"}[chunkId] + ".chunk.js";
};